export default {
  currentCertificate: state => state.current,
}
